import React, {Component} from 'react';
import {Col, Row, Typography, Alert} from "antd";
import DocBloc from "./DocBloc";
import axios from "axios";
import {API_URI} from "../../../constant/Config";
import {t} from '../../../constant/i18n';

const {Title, Text} = Typography;

class DocsInscr extends Component {

    constructor(props) {
        super(props);
        this.state = {
            langueDoc: false
        }
    }

    async componentDidMount() {
        let orderPays = JSON.parse(localStorage.getItem('order_pays'))
        const paramPost = {idPaysSejour: orderPays.idPays};
        const response = await axios.post(API_URI + '/api-member/attributs-pays-langues', paramPost);
        //  this.setState({langueDoc: response.liste[0].lib});
        if (response.data.liste[0]) {
            var langue = t('docsInscr.mustBeWrittenIn') + response.data.liste[0].lib;
            this.setState({
                langueDoc: <Alert
                    message={t('docsInscr.languageTitle')}
                    description={langue}
                    type="warning"
                    showIcon
                />
            });
        }
    }


    render() {
        var messageErreur = ''
        if (typeof this.props.changeStepSend.docValidation !== 'undefined') {
            var messageErreur = <Alert
                message={t('docsInscr.missingDocs')}
                description={t('docsInscr.cvAndLetterRequired')}
                type="error"
                showIcon
            />
        }

        return (
            <div>
                <div className="centerTxt mb10 mt10">
                    <Title level={3}>{t('docsInscr.requiredDocs')}</Title>
                    {messageErreur}
                </div>
                <Row>
                    <Col span={24}>
                        {t('docsInscr.participateIntro')}
                        <br/><br/>
                        {t('docsInscr.applicationConsistOf')}
                        <br/><br/>
                        {t('docsInscr.yourCV')}
                        <br/><br/>
                        {t('docsInscr.letterIntro')}
                        <ul>
                            <li>{t('docsInscr.whyVolunteer')}</li>
                            <li>{t('docsInscr.whyCountryMission')}</li>
                            <li>{t('docsInscr.qualifications')}</li>
                            <li>{t('docsInscr.expectations')}</li>
                            <li>{t('docsInscr.whenStart')}</li>
                            <li>{t('docsInscr.howManyWeeks')}</li>
                        </ul>

                        {t('docsInscr.criminalRecord')}
                        <br/><br/>
                        {t('docsInscr.languageIntro')}
                        <ul>
                            <li>{t('docsInscr.languageFr')}</li>
                            <li>{t('docsInscr.languageEs')}</li>
                            <li>{t('docsInscr.languageEn')}</li>
                        </ul>
                        <br/>
                    </Col>
                </Row>
                <Row justify="space-around" align="middle">
                    <Col span={8}>
                        <DocBloc typeDoc="CV" lib={t('docsInscr.cvLib')}/>
                    </Col>
                    <Col span={8}>
                        <DocBloc typeDoc="LETTRE_PRESENTATION" lib={t('docsInscr.letterLib')}/>
                    </Col>
                    <Col span={8}>
                        <DocBloc typeDoc="CASIER_JUDICIAIRE" lib={t('docsInscr.criminalRecordLib')}/>
                    </Col>
                </Row>

                {this.state.langueDoc}
                < br/>
                <Alert
                    message={t('docsInscr.criminalRecordInfoTitle')}
                    description={t('docsInscr.criminalRecordInfoDesc')}
                    type="info"
                    showIcon
                />
            </div>
        );
    }
}

export default DocsInscr;